export const BUILDING_ICONS: Record<string, string> = {
  // Ancient
  mine: '⛏️', market: '🏪', treasury: '🏦',
  farm: '🌱', mill: '🌾', granary: '🏚️',
  shrine: '🕯️', temple: '⛩️', oracle: '🔮',
  school: '📖', library: '📚', academy: '🏛️',
  // Medieval
  med_forge: '🔨', med_guild_hall: '🏰', med_royal_mint: '👑',
  med_vineyard: '🍇', med_windmill: '🌬️', med_storehouse: '🏠',
  med_chapel: '⛪', med_monastery: '🏔️', med_cathedral: '🕍',
  med_scriptorium: '✍️', med_university: '🎓', med_observatory: '🔭',
  // Renaissance
  mod_bank: '🏦', mod_trading_post: '🚢', mod_merchant_fleet: '⚓',
  mod_plantation: '🌿', mod_greenhouse: '🏡', mod_granary_royal: '🏛️',
  mod_basilica: '⛪', mod_seminary: '📿', mod_vatican_lib: '📕',
  mod_laboratory: '🔬', mod_printing_press: '📰', mod_academy_sci: '🎓',
  // Industrial
  ind_factory: '🏭', ind_stock_exchange: '📈', ind_central_bank: '💵',
  ind_cannery: '🥫', ind_refrigeration: '❄️', ind_agri_corp: '🚜',
  ind_revival_hall: '🕯️', ind_mission: '✝️', ind_grand_temple: '🛕',
  ind_research_lab: '🧪', ind_telegraph: '📡', ind_patent_bureau: '📋',
  // Contemporary
  con_startup: '💻', con_hedge_fund: '📊', con_crypto_mine: '₿',
  con_vertical_farm: '🌿', con_food_lab: '🧬', con_global_logistics: '🚛',
  con_megachurch: '⛪', con_meditation_app: '🧘', con_spiritual_retreat: '🏔️',
  con_data_center: '🖥️', con_ai_lab: '🤖', con_space_agency: '🚀',
  // Future
  fut_quantum_trader: '⚛️', fut_dyson_collector: '☀️', fut_matter_printer: '🖨️',
  fut_bio_synthesizer: '🧬', fut_nano_farm: '🔬', fut_orbital_garden: '🌍',
  fut_neural_temple: '🧠', fut_consciousness_hub: '💫', fut_cosmic_oracle: '🔮',
  fut_quantum_computer: '💻', fut_singularity_engine: '🌀', fut_nexus_archive: '📡',
};
